<template>
  <section class="content-block small-padding adj-margin">
    <transition name="slide-fade-delay">
      <div
        v-if="this.$store.state.edit_slots == null"
        class="block has-white-background"
      >
        <div class="inner-block no-padding">
          <h1 class="title">
            {{ $t("editView.label.reservationNumberNotFound") }}
          </h1>
          <h2 class="subtitle">
            {{ $t("editView.label.reservationNumberNotFoundHint") }}
          </h2>
          <a
            @click="reset_Fn('/')"
            class="button is-outlined is-primary"
          >{{ $t("general.button.goToHomepage") }}</a>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'Start',
  props: {
      msg: {
          type: String,
          default: ''
      }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    goToPath (route) {
      this.$router.push(route)
    },
    reset_Fn (route) {
      this.$store.state.refresh = true
      this.$router.push(route)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.adj-margin {
    margin-top: -40px;
}
</style>
